<template>
  <div id="suppliers" class="px-4 py-4">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'supplier-create' })"
      >
        <v-icon left>
          add_circle
        </v-icon>
        Add
      </v-btn>
    </div>
    <supplier-list />
  </div>
</template>
<script>
import SupplierList from "@/components/supplier_management/SupplierList.vue";
export default {
  components: {
    SupplierList
  }
};
</script>
